// AUTO-GENERATED by scripts/gen-version.js — do not edit by hand.
// Regenerated on every "npm start" / "npm run build".
export const APP_VERSION = "1.0.35";
export const BUILD_TIME = "2026-10-22T07:54:55.839Z";
export const BUILD_ID = "1.0.35+2026-10-22T07:54:55.839Z";
